import { config } from './config';

export const fetchLocations = async () => {
  try {
    const response = await fetch(config.GOOGLE_SHEETS_JSON);
    const json = await response.json();
    const data = json.data;
    console.log(data);
    // Assuming the JSON data is in the format returned by Google Sheets JSON export
    // The exact mapping might need to be adjusted based on your sheet's structure
    return data.map(row => ({
      name: row.Name,
      address: row.Address,
      city: row.City,
      state: row.State,
      zip: row.Zip,
      phone: row.Phone,
      type: row.Type,
      website: row.Website,
      lat: parseFloat(row.Latitude),
      lng: parseFloat(row.Longitude)
    }));
  } catch (error) {
    console.error('Error fetching locations:', error);
    return [];
  }
};




// WEBPACK FOOTER //
// ./src/pages/findGrumple/utils/sheets.js